<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>

  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-select [control]="form.controls['property']" [itemsSource]="properties"></astral-select>
          <astral-input [control]="form.controls['number']"></astral-input>
          <astral-input [control]="form.controls['name']" [helpText]="helpText['NAME']"></astral-input>
          <astral-input [control]="form.controls['costPlace']"></astral-input>
          <astral-input [control]="form.controls['costBearer']"></astral-input>
          <astral-input type="number" [control]="form.controls['floorsInBuilding']"></astral-input>
          <astral-input type="number" [control]="form.controls['buildYear']"></astral-input>
          <astral-input type="number" [control]="form.controls['reconstructionYear']"></astral-input>
          <astral-input [control]="form.controls['centralLocation']"></astral-input>
          <astral-input type="number" [control]="form.controls['latitude']"></astral-input>
          <astral-input type="number" [control]="form.controls['longitude']"></astral-input>
          @if (marketAreas && marketAreas.length) {
            <astral-select [control]="form.controls['dhMarketArea']" [itemsSource]="marketAreas"></astral-select>
          }
        </astral-layout-group>

        @if (customProperties.length) {
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
            @for (property of customProperties; track property) {
              @if (property.showNumeric || property.showInt) {
                <astral-input type="number" [control]="property.form.controls['numericValue']"></astral-input>
              }
              @if (property.showText) {
                <astral-input [control]="property.form.controls['textValue']"></astral-input>
              }
              @if (property.showBoolean) {
                <astral-checkbox [control]="property.form.controls['boolValue']"></astral-checkbox>
              }
              @if (property.showSelection) {
                <astral-select [control]="property.form.controls['textValue']" [itemsSource]="property.selection"></astral-select>
              }
              @if (property.showDate) {
                <astral-date-picker [control]="property.form.controls['dateValue']"></astral-date-picker>
              }
            }
          </astral-layout-group>
        }

        <astral-textarea [control]="form.controls['note']" [rows]="4"></astral-textarea>
        <app-address [group]="form.controls['address']" [helpText]="helpText['BUILDINGADDRESS']" [model]="dataContext.address"></app-address>
      </section>

      <section class="astral-section-surface astral-stack-l">
        <h4 class="astral-heading-with-help">
          <span>{{ 'ENTRANCE.ENTRANCES' | translate }}</span>
          <astral-popover [helpText]="'ENTRANCE.HELP_TEXT.ABOUT_ENTRANCE'"></astral-popover>
        </h4>

        @for (group of $any(entrances.controls); track group; let i = $index) {
          <section class="astral-section-surface astral-section-surface--nested astral-section-surface--compact astral-stack-m">
            <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <astral-input [control]="group.controls['name']"></astral-input>
              <astral-input [control]="group.controls['code']"></astral-input>
              @if (i > 0) {
                <div class="astral-form-adjacent-action">
                  <astral-button variant="secondary" size="small" type="button" icon="trash" labelKey="DELETE_BTN" (click)="removeEntrance(i)"></astral-button>
                </div>
              }
            </astral-layout-group>
          </section>
        }

        <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ENTRANCE.ADD_ENTRANCE" (click)="addEntrance()"></astral-button>
      </section>

      <section class="astral-section-surface astral-stack-l">
        <h4>{{ 'AREA.AREA' | translate }}</h4>

        @for (group of $any(areas.controls); track group; let i = $index) {
          <section class="astral-section-surface astral-section-surface--nested astral-section-surface--compact astral-stack-m">
            <astral-layout-group [columns]="5" [tabletColumns]="2" [mobileColumns]="1">
              <astral-select [control]="group.controls['type']" [itemsSource]="areaTypes"></astral-select>
              <astral-input type="number" [control]="group.controls['value']"></astral-input>
              <astral-date-picker [control]="group.controls['measuredDate']"></astral-date-picker>
              <astral-input [control]="group.controls['measuredBy']"></astral-input>
              <div class="astral-form-adjacent-action">
                <astral-button variant="secondary" size="small" type="button" icon="trash" labelKey="DELETE_BTN" (click)="removeArea(i)"></astral-button>
              </div>
            </astral-layout-group>
          </section>
        }

        <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="AREA.ADD_AREA" (click)="addArea()"></astral-button>
      </section>

      @if (!isNew) {
        <section class="astral-section-surface astral-stack-l">
          <h4>{{ 'BUILDING_SPACE.BUILDING_SPACES' | translate }}</h4>

          @for (group of $any(buildingSpaces.controls); track group; let i = $index) {
            <section class="astral-section-surface astral-section-surface--nested astral-section-surface--compact astral-stack-m">
              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                <astral-input [control]="group.controls['caption']"></astral-input>
                <astral-input type="number" [control]="group.controls['area']"></astral-input>
                <div class="astral-form-adjacent-action">
                  <astral-button variant="secondary" size="small" type="button" icon="trash" labelKey="DELETE_BTN" (click)="removeBuildingSpace(i)"></astral-button>
                </div>
                <div class="astral-form-adjacent-action">
                  <astral-button variant="secondary" size="small" type="button" labelKey="EDIT_BTN" (click)="editBuildingSpace(i)"></astral-button>
                </div>
              </astral-layout-group>
            </section>
          }

          <astral-button
            variant="primary"
            size="small"
            type="button"
            icon="plus"
            labelKey="BUILDING_SPACE.ADD_BUILDING_SPACE"
            (click)="addBuildingSpace()"
          ></astral-button>
        </section>
      }

      <section class="astral-section-surface astral-form-stack">
        <astral-textarea [control]="form.controls['buildingDescription']" [rows]="6"></astral-textarea>
        <astral-textarea [control]="form.controls['areaDescription']" [rows]="6"></astral-textarea>
      </section>

      <div class="astral-accordion-stack">
        @if (!dataContext.isNew && useDhMarketShowings$ | async) {
          <astral-accordion header="BUILDING_FORM.RESPONSIBILITIES">
            <div class="astral-stack-l">
              <h5>{{ 'BUILDING_FORM.DHMARKET' | translate }}</h5>
              <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                <app-autocomplete-remote-paged
                  [control]="form.controls.lettingShowingOrdinary"
                  [defaultSearch]="'*'"
                  [service]="lettingAdvertismentOrdinaryService"
                  (itemSelected)="lettingOrdinaryChanged($event)"
                ></app-autocomplete-remote-paged>
                @if (selectedOrdinary) {
                  <astral-input label="COMMON.EMAIL_ADDRESS" type="email" [value]="selectedOrdinary.email" [readonly]="true"></astral-input>
                  <astral-input label="COMMON.PHONE_NUMBER" type="phone" [value]="selectedOrdinary.phone" [readonly]="true"></astral-input>
                }
              </astral-layout-group>
            </div>
          </astral-accordion>
        }

        @if (rentalObjectsExist) {
          <astral-accordion [header]="'DASHBOARD.OVERVIEW_ITEM_HEADER'">
            <astral-layout-group [columns]="2" [tabletColumns]="1" [mobileColumns]="1">
              @if (dwellingExist) {
                <section class="astral-section-surface astral-stack-m">
                  <h5>{{ 'STATISTICS.DWELLING_HEADER' | translate }}</h5>
                  <app-residential-property-statistics [model]="dwelling"></app-residential-property-statistics>
                </section>
              }
              @if (premisesExist) {
                <section class="astral-section-surface astral-stack-m">
                  <h5>{{ 'STATISTICS.PREMISES_HEADER' | translate }}</h5>
                  <app-residential-property-statistics [model]="premises"></app-residential-property-statistics>
                </section>
              }
            </astral-layout-group>
          </astral-accordion>
        }
        @if (!dataContext.isNew) {
          <astral-accordion
            [helpText]="'TENANT.HELP_TEXT.DOCUMENT_LIST'"
            [header]="'DOCUMENT.LIST_HEADER'"
            (stateChanged)="documentComponent.loadDocuments()"
          >
            <app-building-documents [building]="dataContext"></app-building-documents>
          </astral-accordion>
        }
      </div>
    </form>
  }
</section>
